import { useGetAllBaseTicketClasses } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  regionId?: string | null | undefined;
}
export default function BaseTicketClassInput({ regionId, ...props }: Props) {
  const { data, isLoading } = useGetAllBaseTicketClasses();

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.name}
          </Select.Option>
        );
      })}
    </Select>
  );
}
